export const featureFlag = {
  invoice_details_feature_enabled: "invoice-details-feature-enabled",
  free_subscription_for_trial: "free-subscription-for-trial",
  bank_integration_feature_enabled: "bank-integration-feature-enabled",
  customized_payment_purpose_feature: "customized-payment-purpose-feature",
  homepage_headlines: "homepage-headlines",
};

export enum testingVariants {
  CONTROL = "control",
  TEST = "test",
}
